import { render, staticRenderFns } from "./aChmEditablePrice.vue?vue&type=template&id=3ff2bceb&scoped=true"
import script from "./aChmEditablePrice.vue?vue&type=script&lang=js"
export * from "./aChmEditablePrice.vue?vue&type=script&lang=js"
import style0 from "./aChmEditablePrice.vue?vue&type=style&index=0&id=3ff2bceb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff2bceb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VMenu,VTextField})
